export default __webpack_public_path__ + "static/media/cabello-corto-hombre-negro.1acb4c85.png";